// extracted by mini-css-extract-plugin
export default {"dataGrid":"DashboardStatChartCard_dataGrid__ilt1L","mainTitle":"DashboardStatChartCard_mainTitle__yEL48"};